import { render, staticRenderFns } from "./TablaSimTodos.vue?vue&type=template&id=6f616bb4&"
import script from "./TablaSimTodos.vue?vue&type=script&lang=ts&"
export * from "./TablaSimTodos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6f616bb4', component.options)
    } else {
      api.reload('6f616bb4', component.options)
    }
    module.hot.accept("./TablaSimTodos.vue?vue&type=template&id=6f616bb4&", function () {
      api.rerender('6f616bb4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MovimientoDispositivos/TablaSimTodos.vue"
export default component.exports